<template>

  <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="center" vs-w="12">
  <!-- {{bool}} -->
    <select v-model="bool"
    @change="update(params)"
      class="w-100 selectExample mt-2 customSelect">
     <option :key="index"
       :value="item.optionsvaluename" 
       :label="item.optionsvaluename"
        v-for="(item,index) 
        in params.colDef.CellRendererParams.custom_fields[0].multivalue"
       class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'
export default {
  components:{
    vSelect
  },
  data () {
    return {
      bool: null,
      countryList:[],
      addDetailsModal:false,
      
    }
  },
  /*  created () {
  }, */
  mounted () {
    this.bool= this.params.data[this.params.colDef.CellRendererParams.item_name]
    
  },

  methods: {
      async update(data1){
          const data = []
          data.is_dynamic = true
      data.colId = this.params.colDef.field
      data.user_id = this.params.data.basic_details.client_users_id
      data.fieldvalue = this.bool
          this.params.colDef.filterParams.Update_client(data,this.params.data.basic_details.address)
      },
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
